import { Box, IconButton, Input, InputGroup, Text } from '@chakra-ui/react';

import { Icons } from '@/assets/Icons';
import { settings } from '@/settings';

import { topbarCss } from './Topbar.styles';
import { UserMenu } from './UserMenu';

type TopbarProps = {
  onOpenMenu?: () => void;
};

export const Topbar = ({ onOpenMenu }: TopbarProps) => (
  <Box as="header" className="Topbar" css={topbarCss}>
    <Box className="tenant">
      {onOpenMenu && (
        <IconButton
          className="menu-button"
          variant="ghost"
          size="sm"
          aria-label="Open navigation"
          onClick={onOpenMenu}
        >
          <Icons.LuMenu />
        </IconButton>
      )}
      <Text className="tenant-name">{settings.TENANT_NAME}</Text>
    </Box>

    <InputGroup
      className="search"
      startElement={<Icons.LuSearch opacity={0.7} />}
    >
      <Input
        type="search"
        aria-label="Search"
        placeholder="Search applications, agents, or integrations..."
      />
    </InputGroup>

    <Box className="actions">
      <IconButton
        className="bell"
        variant="ghost"
        size="sm"
        aria-label="Notifications"
      >
        <Icons.LuBell />
      </IconButton>
      <UserMenu />
    </Box>
  </Box>
);
